import { Box, IconButton, Tooltip } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";

export interface ActionButtonsProps {
  onView?: () => void;
  onEdit?: () => void;
  onDelete?: () => void;
}

const GOLD_GLOW = "0 0 0 2px rgba(5,141,208,0.2)";

// Premium pill IconButton style — declared locally so the rest of the app's
// IconButtons (topbar, dialogs, etc.) stay on MUI defaults.
const baseButton = {
  borderRadius: "8px",
  padding: "6px",
  border: "1px solid #E5E7EB",
  backgroundColor: "#FFFFFF",
  transition: "all 0.2s ease",
  "&:hover": { transform: "translateY(-1px)" },
  "&:active": { transform: "scale(0.96)" },
};

export default function ActionButtons({ onView, onEdit, onDelete }: ActionButtonsProps) {
  return (
    <Box
      sx={{
        display: "inline-flex",
        gap: "6px",
        padding: "4px",
        borderRadius: "12px",
        background: "linear-gradient(145deg, #f9fafb, #ffffff)",
        border: "1px solid #E5E7EB",
      }}
    >
      {onView && (
        <Tooltip title="View" arrow>
          <IconButton
            size="small"
            onClick={onView}
            sx={{
              ...baseButton,
              color: "#058dd0",
              "&:hover": {
                ...baseButton["&:hover"],
                backgroundColor: "#E3F2FB",
                boxShadow: GOLD_GLOW,
              },
            }}
          >
            <VisibilityIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      )}

      {onEdit && (
        <Tooltip title="Edit" arrow>
          <IconButton
            size="small"
            onClick={onEdit}
            sx={{
              ...baseButton,
              color: "#1D4ED8",
              "&:hover": {
                ...baseButton["&:hover"],
                backgroundColor: "#DBEAFE",
                boxShadow: GOLD_GLOW,
              },
            }}
          >
            <EditIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      )}

      {onDelete && (
        <Tooltip title="Delete" arrow>
          <IconButton
            size="small"
            onClick={onDelete}
            sx={{
              ...baseButton,
              color: "#EF4444",
              "&:hover": {
                ...baseButton["&:hover"],
                backgroundColor: "#FEE2E2",
                boxShadow: GOLD_GLOW,
              },
            }}
          >
            <DeleteIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      )}
    </Box>
  );
}
